<template>
  <div class="player-template" theme>
    <div id="theme-player-header" />
    <div id="theme-player-leftside" />
    <div id="theme-player-content" />
    <div id="theme-player-rightside" />
    <div id="theme-player-footer" />
    <div id="css-loading-checking-element" />
    <b-modal
      id="play-continue-confirm-modal"
      ref="playContinueConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="continuePlay()"
      @cancel="initPlay()"
    >
      <p class="my-4" v-html="$t('player.modal.text.continue')" />
    </b-modal>
  </div>
</template>

<script>
import Vimeo from '@vimeo/player'
export default {
  data() {
    return {
      path: 'player',
      parts: [
        {
          elem: '#theme-player-header',
          htmlFile: 'header'
        },
        {
          elem: '#theme-player-leftside',
          htmlFile: 'leftside'
        },
        {
          elem: '#theme-player-content',
          htmlFile: 'content'
        },
        {
          elem: '#theme-player-rightside',
          htmlFile: 'rightside'
        },
        {
          elem: '#theme-player-footer',
          htmlFile: 'footer'
        }
      ]
    }
  },
  mounted() {
    if (!this.loggedInUser) {
      this.notLoggedIn()
      return
    }
    this.$eventHub.$on('video-changed', this.onVideoChanged)
  },
  beforeDestroy() {
    this.$eventHub.$off('video-changed', this.onVideoChanged)
  },
  methods: {
    onVideoChanged(params) {
      if (this.componentId === parseInt(params.componentId)) {
        this.currentComposition = params.composition
        this.initPlayer()
      }
    },
    continuePlay() {
      this.player.setCurrentTime(
        this.currentComposition.atnlc.lastPlayHist.endTime / 1000
      )
      this.player.play()
    },
    initPlay() {
      this.player.setCurrentTime(0)
      this.player.play()
    },
    initPlayer() {
      const self = this
      if ($(this.$el).find('iframe').length === 0) {
        setTimeout(this.initPlayer, 100)
        return
      }
      this.iframe = $(this.$el)
        .find('iframe')
        .get(0)
      this.player = new Vimeo(this.iframe)

      this.player.on('play', function(param) {
        self.bgnTime = param.seconds * 1000
        self.endTime = param.seconds * 1000
        self.pt = 0
        self.savePlayHist(true)
      })
      this.player.on('ended', function(param) {
        self.endTime = param.seconds * 1000
        self.pt = param.percent * 100
        self.savePlayHist()
        self.bgnTime = undefined
        self.endTime = undefined
        self.pt = undefined
      })
      this.player.on('pause', function(param) {
        self.endTime = param.seconds * 1000
        self.pt = param.percent * 100
        self.savePlayHist()
        self.bgnTime = undefined
        self.endTime = undefined
        self.pt = undefined
      })
      this.player.on('timeupdate', function(param) {
        if (self.bgnTime === undefined) {
          self.bgnTime = param.seconds * 1000
        }
        self.endTime = param.seconds * 1000
        self.pt = param.percent * 100
        self.savePlayHist()
      })
      if (
        this.currentComposition &&
        this.currentComposition.atnlc &&
        this.currentComposition.atnlc.lastPlayHist &&
        this.currentComposition.atnlc.lastPlayHist.endTime &&
        this.currentComposition.atnlc.lastPlayHist.pt !== 100
      ) {
        this.showModal('playContinueConfirmModalRef')
      } else {
        this.player.play()
      }
    },
    savePlayHist(start) {
      if (start) {
        this.playHistId = undefined
      }
      if (!start && !this.playHistId) {
        return
      }
      let url =
        'atnlc/savePlayHist?goodsCompositionId=' +
        this.$route.query.goodsCompositionId
      if (this.$route.query.atnlcCompositionId) {
        url += '&atnlcCompositionId=' + this.$route.query.atnlcCompositionId
      }
      if (this.playHistId) {
        url += '&playHistId=' + this.playHistId
      }
      if (this.bgnTime !== undefined) {
        url += '&bgnTime=' + Math.floor(this.bgnTime)
      } else {
        url += '&bgnTime=0'
      }
      if (this.endTime !== undefined) {
        url += '&endTime=' + Math.floor(this.endTime)
      }
      if (this.pt !== undefined) {
        url += '&pt=' + this.pt
      }
      url += '&width=' + $(document).width()
      url += '&height=' + $(document).height()
      this.$axios
        .$get(url, {
          no_loading: true,
          progress: false
        })
        .then(response => {
          if (response.resultCode === 'success') {
            if (response.data) {
              this.playHistId = response.data.id
            }
          }
        })
    },
    notLoggedIn() {
      if (Object.keys(this.messages).length === 0) {
        setTimeout(this.notLoggedIn, 50)
        return
      }
      alert(this.$t('common.notification.login_required'))
      window.close()
    }
  }
}
</script>
